import { addTrailingZeros } from "@js-app/services/helpers/math";

export class Stats {
  constructor(statsObject = {}) {
    this.stats = statsObject;
  }

  getPlainStats() {
    return this.allStats;
  }

  get allStats() {
    if (
      this.stats?.OperationsStats?.All.StatByCurrency === undefined ||
      this.stats?.OperationsStats?.All.StatByCurrency === null ||
      this.stats?.OperationsStats?.All.StatByCurrency.length === 0
    ) {
      return {
        sum: addTrailingZeros(
          (
            parseInt(this.stats?.OperationsStats?.All?.Sum || 0) / 100
          ).toLocaleString("uk-UA")
        ),
        count: parseInt(
          this.stats?.OperationsStats?.All?.Count || 0
        ).toLocaleString(),
        sumPlain: this.stats?.OperationsStats?.All?.Sum || 0,
        countPlain: this.stats?.OperationsStats?.All?.Count || 0,
      };
    }

    return (
      Object.entries(this.stats?.OperationsStats?.All?.StatByCurrency ?? {})
        .map(([currency, { Sum, Count }]) => ({
          currency,
          sum: addTrailingZeros((parseInt(Sum) / 100).toLocaleString("uk-UA")),
          count: parseInt(Count).toLocaleString(),
          sumPlain: Sum,
          countPlain: Count,
        }))
        .sort((a, b) => b.sumPlain - a.sumPlain)[0] ?? null
    );
  }

  get allStatsByCurrencies() {
    return Object.entries(
      this.stats?.OperationsStats?.All?.StatByCurrency ?? {}
    )
      .map(([currency, { Sum, Count }]) => ({
        currency,
        sum: addTrailingZeros((parseInt(Sum) / 100).toLocaleString("uk-UA")),
        count: parseInt(Count).toLocaleString(),
        sumPlain: Sum,
        countPlain: Count,
        midBill: addTrailingZeros(
          Math.round(Sum / Count / 100).toLocaleString("uk-UA")
        ),
      }))
      .sort((a, b) => b.sumPlain - a.sumPlain);
  }

  get typedStats() {
    if (!this.isCurrencyStats) {
      try {
        return Array.isArray(this.stats?.OperationTypeIDStats)
          ? {}
          : this.stats?.OperationTypeIDStats || {};
      } catch (e) {
        return {};
      }
    }

    if (Array.isArray(this.stats?.OperationTypeIDStats)) {
      return {};
    }

    if (!this.stats?.OperationTypeIDStats) {
      return {};
    }

    const currency = this.allStats.currency;

    let formattedTypedStat = {};

    for (let typeKey in this.stats.OperationTypeIDStats) {
      formattedTypedStat[typeKey] = {};

      for (let statKey in this.stats.OperationTypeIDStats[typeKey]) {
        if (
          this.stats.OperationTypeIDStats[typeKey][statKey].StatByCurrency !==
          undefined
        ) {
          if (
            this.stats.OperationTypeIDStats[typeKey][statKey].StatByCurrency !==
            null
          ) {
            formattedTypedStat[typeKey][statKey] =
              this.stats.OperationTypeIDStats[typeKey][statKey].StatByCurrency[
                currency
              ];
          } else {
            formattedTypedStat[typeKey][statKey] = { Count: 0, Sum: 0 };
          }
        } else {
          formattedTypedStat[typeKey][statKey] =
            this.stats.OperationTypeIDStats[typeKey][statKey];
        }
      }
    }

    return formattedTypedStat;
  }

  get isCurrencyStats() {
    return this.stats?.OperationsStats?.All.StatByCurrency !== undefined;
  }
}
